import './Sidebar.scss';
import { NavLink } from 'react-router-dom';
import { ReactComponent as Logo } from '../../images/logo.svg';
import { useTranslation } from 'react-i18next';
import { EMAIL } from '../../core/constants';

export interface Category {
  name: string;
  links: {
    label: string;
    icon: JSX.Element;
    to: string;
    marked?: boolean;
  }[];
}

interface Props {
  categories: Category[];
  header?: JSX.Element;
}

export const Sidebar = ({ categories, header }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <div className='Sidebar__offset flex-shrink-0' />
      <div className='Sidebar w-100 fixed-top d-flex flex-column'>
        <div
          className='py-2 d-flex align-items-center mb-4 px-3'
          style={{
            height: 56,
          }}
        >
          <Logo className='Sidebar__logo' />
        </div>
        <div
          className='px-3 Scrollbar d-flex flex-column justify-content-between flex-grow-1'
          style={{
            overflowY: 'auto',
          }}
        >
          <div>
            {header}
            {categories.map((c) => (
              <div key={c.name} className='mb-2'>
                <div className='mb-2 fw-bold'>{t(c.name)}</div>
                <div className='d-flex flex-column'>
                  {c.links.map((l) => (
                    <NavLink
                      key={l.label}
                      to={l.to}
                      className='Sidebar__link text-decoration-none d-flex align-items-center mx-n2 mb-2 py-1 ps-2'
                      exact
                      data-testid={`sidebar-link-${l.label}`}
                    >
                      <div className='flex-shrink-0 d-flex align-items-center'>
                        {l.icon}
                      </div>
                      <span className='ms-1 text-truncate'>{t(l.label)}</span>
                      {l.marked && (
                        <div className='Sidebar__marked ms-2 rounded-circle' />
                      )}
                    </NavLink>
                  ))}
                </div>
              </div>
            ))}
          </div>
          <div className='pt-3 pb-3'>
            <div className='mb-3'>
              <a href={`mailto:${EMAIL}`}>{EMAIL}</a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
